import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {handleSelfReturn, openSelfReturn } from '../../reducers/uiSlice';
import ReturnSearch from './ReturnSearch';
import ManualProcess from './ManualProcess';
import ReturnRecord from './ReturnRecord';
import MarkPosition from './MarkPosition';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        minHeight: '80vh'
    },
    gridStyle: { 
        marginTop: 60 
    }
}));

function SelfReturn() {
    const classes = useStyles();
    const {t} = useTranslation('selfReturn');
    const dispatch = useDispatch();

    const openModal = useSelector(openSelfReturn);

    return (
        <Dialog 
            onClose={handleClose} 
            open={openModal}
            fullWidth={true}
            maxWidth='xl'
            scroll='body'
        >    
            <DialogTitle>
                {t('title_self_return')}
                <Tooltip title={t('common:cancel')} aria-label="cancel" style={{float: "right"}}>
                    <CloseIcon onClick={handleClose}></CloseIcon>
                </Tooltip>                                   
            </DialogTitle>
            <DialogContent dividers  className={classes.root} >
                <Fragment>
                    <Grid container alignContent='space-between'>
                        <Grid item xs={6}>
                            <ReturnSearch/>
                        </Grid>
                        <Grid item xs={6}>
                            <MarkPosition/>
                        </Grid>                        
                    </Grid>                   
                    <ManualProcess/>
                    <ReturnRecord/>
                </Fragment> 
            </DialogContent>
        </Dialog>
    );

    /**
     * close the dialog
    */
    function handleClose() {
        dispatch(handleSelfReturn(false))
    }
}

export default SelfReturn;